const SoonBlur = () => {
  return (
    <div className="absolute inset-0 backdrop-blur-[6.6px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
      <p className="text-black text-[1vw] leading-[1.1] font-luxora-regular max-lg:text-[3.73vw]">
        Soon
      </p>
    </div>
  );
};

export default SoonBlur;
